import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";

// Get the root element from index.html
const rootElement = document.getElementById("root") as HTMLElement;

// Create a React root
const root = ReactDOM.createRoot(rootElement);

// Render your main App component
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);
